import { useBrandingContext } from 'containers/App/hooks';
import { ErrorBoundaryApp } from 'core';
import React from 'react';

export const withAppWrapper = (Component: any) => (props: any) => {
  const brandingContextValues = useBrandingContext();

  return (
    <ErrorBoundaryApp>
      <Component {...props} brandingContextValues={brandingContextValues} />
    </ErrorBoundaryApp>
  );
};
